export default {
  allActivityTemplates: (state) => state.activityTemplates,
  allTemplateBundles: (state) => state.templateBundles,
  templatesLoading: (state) => state.templatesLoading
}
